(() => {
  'use strict';

  function formatMoney(cents, currency){
    const value = Number(cents || 0) / 100;
    try{
      return new Intl.NumberFormat('es-CO',{style:'currency',currency:currency || 'COP',maximumFractionDigits:0}).format(value);
    }catch(e){
      return '$' + Math.round(value).toLocaleString('es-CO');
    }
  }

  function splitName(full){
    const clean = (full || '').trim().replace(/\s+/g,' ');
    if(!clean) return {first:'',last:''};
    const parts = clean.split(' ');
    if(parts.length === 1) return {first:parts[0],last:''};
    return {first:parts.slice(0,-1).join(' '),last:parts[parts.length-1]};
  }

  function currentTracking(){
    const p = new URLSearchParams(location.search);
    const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ttclid'];
    const out = {};
    keys.forEach(k => { const v=p.get(k); if(v) out[k]=v.slice(0,250); });
    return out;
  }

  document.querySelectorAll('[data-magno-root]').forEach(root => {
    let variants = [];
    try{ variants = JSON.parse(root.querySelector('[data-magno-variants-json]').textContent || '[]'); }catch(e){}
    const currency = root.dataset.currency || window.MAGNO_SHOP?.currency || 'COP';
    const discountCode = root.dataset.discountCode || '';
    const discountPesos = Number(root.dataset.discountAmount || 5000);
    const discountCents = discountPesos * 100;
    const exitEnabled = root.dataset.exitEnabled === 'true';
    const sectionKey = root.dataset.sectionKey || 'magno';
    let selectedId = Number(root.dataset.initialVariant || (variants[0] && variants[0].id));
    let discountAccepted = sessionStorage.getItem('magnoDiscountAccepted:'+sectionKey) === '1';
    let exitShown = sessionStorage.getItem('magnoExitShown:'+sectionKey) === '1';

    const productHandle = root.dataset.productHandle || 'product';
    const attemptStorageKey = 'magnoCheckoutAttempt:' + productHandle;
    const completedStorageKey = 'magnoCompletedOrder:' + productHandle;
    const COMPLETED_LOCK_MS = 24 * 60 * 60 * 1000; // 24 h

    function randomAttemptId(){
      try{
        if(window.crypto?.randomUUID) return window.crypto.randomUUID();
      }catch(_){}
      return 'm-' + Date.now().toString(36) + '-' +
        Math.random().toString(36).slice(2,12);
    }
    function getOrCreateAttemptId(){
      let id = '';
      try{ id = localStorage.getItem(attemptStorageKey) || ''; }catch(_){}
      if(!id){
        id = randomAttemptId();
        try{ localStorage.setItem(attemptStorageKey,id); }catch(_){}
      }
      return id;
    }
    function readCompletedOrder(){
      try{
        const raw = localStorage.getItem(completedStorageKey);
        if(!raw) return null;
        const data = JSON.parse(raw);
        if(!data?.orderId || !data?.attemptId || !data?.at) return null;
        if(Date.now() - Number(data.at) > COMPLETED_LOCK_MS){
          localStorage.removeItem(completedStorageKey);
          localStorage.removeItem(attemptStorageKey);
          return null;
        }
        return data;
      }catch(_){ return null; }
    }
    function saveCompletedOrder(data,attemptId){
      const record = {
        orderId:data.orderId || '',
        orderName:data.orderName || '',
        whatsappUrl:data.whatsappUrl || '',
        attemptId,
        at:Date.now()
      };
      try{
        localStorage.setItem(completedStorageKey,JSON.stringify(record));
        localStorage.setItem(attemptStorageKey,attemptId);
      }catch(_){}
      return record;
    }
    function clearCompletedOrder(){
      try{
        localStorage.removeItem(completedStorageKey);
        localStorage.removeItem(attemptStorageKey);
      }catch(_){}
    }

    const mainImage = root.querySelector('[data-magno-main-image]');
    const modalImage = root.querySelector('[data-magno-modal-image]');
    const variantSelect = root.querySelector('[data-magno-checkout-variant]');
    const overlay = root.querySelector('[data-magno-checkout-overlay]');
    const exitOverlay = root.querySelector('[data-magno-exit-overlay]');

    function selectedVariant(){ return variants.find(v => Number(v.id) === Number(selectedId)) || variants[0]; }
    function priceCents(){ return Number(selectedVariant()?.price || 0); }
    function visualPriceCents(){ return Math.max(0, priceCents() - (discountAccepted ? discountCents : 0)); }
    function variantImage(v){ return v?.featured_image?.src || v?.featured_image || ''; }

    function syncUI(){
      const v = selectedVariant();
      const price = visualPriceCents();
      root.querySelectorAll('[data-magno-live-price]').forEach(el => el.textContent = formatMoney(price,currency));
      root.querySelectorAll('[data-magno-base-price]').forEach(el => el.textContent = formatMoney(priceCents(),currency));
      root.querySelectorAll('[data-magno-discount-chip]').forEach(el => el.classList.toggle('show',discountAccepted));
      if(variantSelect) variantSelect.value = String(selectedId);
      const src = variantImage(v);
      if(src && modalImage) modalImage.src = src;
    }

    function selectVariant(id, image){
      selectedId = Number(id);
      root.querySelectorAll('[data-magno-variant]').forEach(b => b.classList.toggle('is-selected', Number(b.dataset.variantId) === selectedId));
      if(image && mainImage) mainImage.src = image;
      syncUI();
    }

    root.querySelectorAll('[data-magno-thumb]').forEach(btn => btn.addEventListener('click', () => {
      root.querySelectorAll('[data-magno-thumb]').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      if(mainImage && btn.dataset.image) mainImage.src = btn.dataset.image;
    }));

    root.querySelectorAll('[data-magno-variant]').forEach(btn => btn.addEventListener('click', () => {
      selectVariant(btn.dataset.variantId, btn.dataset.image);
    }));

    if(variantSelect){
      variantSelect.addEventListener('change', () => {
        const opt = variantSelect.selectedOptions[0];
        selectVariant(variantSelect.value, opt?.dataset.image || '');
      });
    }

    function lock(){ document.documentElement.classList.add('magno-modal-open'); document.body.classList.add('magno-modal-open'); }
    function unlock(){ document.documentElement.classList.remove('magno-modal-open'); document.body.classList.remove('magno-modal-open'); }
    function showCompletedOrder(record){
      if(!record) return false;
      if(successOrderText){
        successOrderText.textContent = record.orderName
          ? 'Pedido '+record.orderName+' ya fue registrado. No se generará otro pedido.'
          : 'Este pedido ya fue registrado. No se generará otro pedido.';
      }
      if(successWhatsApp && record.whatsappUrl){
        successWhatsApp.href = record.whatsappUrl;
      }
      if(successOverlay){
        successOverlay.classList.add('open');
        successOverlay.setAttribute('aria-hidden','false');
        lock();
      }
      return true;
    }

    function openCheckout(){
      const completed = readCompletedOrder();
      if(completed){
        showCompletedOrder(completed);
        return;
      }
      if(!overlay) return;
      overlay.classList.add('open'); overlay.setAttribute('aria-hidden','false'); lock(); syncUI();
    }
    function closeCheckout(showExit){
      if(!overlay) return;
      overlay.classList.remove('open'); overlay.setAttribute('aria-hidden','true'); unlock();
      if(showExit && exitEnabled && !discountAccepted && !exitShown) setTimeout(showExitOffer,120);
    }
    function showExitOffer(){
      if(!exitOverlay || discountAccepted || exitShown || !exitEnabled) return;
      exitShown = true; sessionStorage.setItem('magnoExitShown:'+sectionKey,'1');
      exitOverlay.classList.add('open'); exitOverlay.setAttribute('aria-hidden','false'); lock();
    }
    function dismissExit(){
      if(!exitOverlay) return;
      exitOverlay.classList.remove('open'); exitOverlay.setAttribute('aria-hidden','true'); unlock();
    }
    function acceptDiscount(){
      discountAccepted = true; sessionStorage.setItem('magnoDiscountAccepted:'+sectionKey,'1');
      dismissExit(); syncUI(); setTimeout(openCheckout,120);
    }

    root.querySelectorAll('[data-magno-open-checkout]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); openCheckout(); }));
    root.querySelectorAll('[data-magno-close-checkout]').forEach(el => el.addEventListener('click', () => closeCheckout(true)));
    root.querySelectorAll('[data-magno-exit-yes]').forEach(el => el.addEventListener('click', acceptDiscount));
    root.querySelectorAll('[data-magno-exit-no],[data-magno-exit-close]').forEach(el => el.addEventListener('click', dismissExit));
    if(overlay) overlay.addEventListener('click',e => { if(e.target === overlay) closeCheckout(true); });
    if(exitOverlay) exitOverlay.addEventListener('click',e => { if(e.target === exitOverlay) dismissExit(); });

    if(exitEnabled){
      document.addEventListener('mouseout',e => {
        if(e.clientY <= 2 && !(overlay?.classList.contains('open')) && !(exitOverlay?.classList.contains('open'))) showExitOffer();
      });
      try{
        history.pushState({magnoExitGuard:true},'',location.href);
        addEventListener('popstate',() => {
          if(!discountAccepted && !exitShown){ showExitOffer(); try{history.pushState({magnoExitGuard:true},'',location.href)}catch(e){} }
        });
      }catch(e){}
    }

    const form = root.querySelector('[data-magno-checkout-form]');
    const submitOrderButton = root.querySelector('[data-magno-submit-order]');
    const orderError = root.querySelector('[data-magno-order-error]');
    const successOverlay = root.querySelector('[data-magno-success-overlay]');
    const successOrderText = root.querySelector('[data-magno-success-order]');
    const successWhatsApp = root.querySelector('[data-magno-success-whatsapp]');
    const newOrderButton = root.querySelector('[data-magno-new-order]');

    function showOrderError(message){
      if(!orderError) return;
      orderError.hidden = false;
      orderError.textContent = message || 'No pudimos registrar el pedido. Intenta nuevamente.';
    }
    function clearOrderError(){
      if(!orderError) return;
      orderError.hidden = true;
      orderError.textContent = '';
    }
    newOrderButton?.addEventListener('click', () => {
      clearCompletedOrder();
      if(successOverlay){
        successOverlay.classList.remove('open');
        successOverlay.setAttribute('aria-hidden','true');
      }
      unlock();
      if(submitOrderButton){
        submitOrderButton.disabled = false;
        submitOrderButton.classList.remove('magno-order-locked');
        submitOrderButton.textContent = 'CONFIRMAR PEDIDO CONTRAENTREGA';
      }
      try{ form?.reset(); }catch(_){}
      window.scrollTo({top:0,behavior:'smooth'});
    });

    function getCodEndpoint(){
      return String(window.MAGNO_CONFIG?.codEndpoint || '').trim();
    }

    if(form){
      form.addEventListener('submit', async e => {
        e.preventDefault();
        clearOrderError();

        const priorCompleted = readCompletedOrder();
        if(priorCompleted){
          showCompletedOrder(priorCompleted);
          return;
        }

        if(!form.reportValidity()) return;

        const v = selectedVariant();
        if(!v || !v.available){
          showOrderError('Esta variante no está disponible en este momento.');
          return;
        }

        const endpoint = getCodEndpoint();
        if(!endpoint || endpoint.includes('REEMPLAZAR-CON-TU-WORKER')){
          showOrderError('El servicio de pedidos no está disponible en este momento. Intenta nuevamente.');
          return;
        }

        const fd = new FormData(form);
        if(String(fd.get('website') || '').trim()) return; // honeypot

        const qty = Math.min(3, Math.max(1, Number(fd.get('quantity') || 1)));
        const checkoutAttemptId = getOrCreateAttemptId();

        const payload = {
          checkoutAttemptId,
          variantId: String(v.id),
          quantity: qty,
          nombre: String(fd.get('nombre') || '').trim(),
          telefono: String(fd.get('telefono') || '').trim(),
          email: String(fd.get('email') || '').trim(),
          direccion: String(fd.get('direccion') || '').trim(),
          barrio: String(fd.get('barrio') || '').trim(),
          departamento: String(fd.get('departamento') || '').trim(),
          ciudad: String(fd.get('ciudad') || '').trim(),
          nota: String(fd.get('nota') || '').trim(),
          marketing: fd.get('marketing') === 'on',
          discountAccepted,
          productHandle: root.dataset.productHandle || '',
          landingUrl: location.href,
          tracking: currentTracking()
        };

        if(!payload.nombre || !payload.telefono || !payload.direccion || !payload.departamento || !payload.ciudad){
          showOrderError('Completa los campos obligatorios para registrar el pedido.');
          return;
        }

        const originalText = submitOrderButton?.textContent || 'CONFIRMAR PEDIDO CONTRAENTREGA';
        if(submitOrderButton){
          submitOrderButton.disabled = true;
          submitOrderButton.textContent = 'REGISTRANDO PEDIDO...';
        }

        try{
          document.dispatchEvent(new CustomEvent('magno:checkout_started',{
            detail:{variantId:v.id,quantity:qty,value:visualPriceCents()/100,currency}
          }));

          const response = await fetch(endpoint, {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify(payload)
          });

          let data = {};
          try{ data = await response.json(); }catch(_){}

          if(!response.ok || !data.ok){
            throw new Error(data.error || data.message || 'No pudimos registrar tu pedido. Intenta nuevamente.');
          }

          document.dispatchEvent(new CustomEvent('magno:order_created',{
            detail:{
              orderId:data.orderId,
              orderName:data.orderName,
              value:Number(data.total || visualPriceCents()/100),
              currency:data.currency || currency,
              variantId:v.id,
              quantity:qty
            }
          }));

          // Hooks for Meta/TikTok once their pixels are installed.
          try{
            if(typeof window.fbq === 'function'){
              window.fbq('track','Purchase',{
                value:Number(data.total || visualPriceCents()/100),
                currency:data.currency || currency,
                content_ids:[String(v.id)],
                content_type:'product'
              });
            }
          }catch(_){}
          try{
            if(window.ttq && typeof window.ttq.track === 'function'){
              window.ttq.track('CompletePayment',{
                value:Number(data.total || visualPriceCents()/100),
                currency:data.currency || currency,
                content_id:String(v.id),
                quantity:qty
              });
            }
          }catch(_){}

          sessionStorage.setItem('magnoLastOrder', JSON.stringify({
            orderId:data.orderId,
            orderName:data.orderName,
            at:Date.now()
          }));

          const completedRecord = saveCompletedOrder(data, checkoutAttemptId);
          if(submitOrderButton){
            submitOrderButton.disabled = true;
            submitOrderButton.classList.add('magno-order-locked');
          }

          // Close checkout and show success briefly.
          if(overlay){
            overlay.classList.remove('open');
            overlay.setAttribute('aria-hidden','true');
          }
          unlock();

          if(successOrderText){
            successOrderText.textContent = (data.orderName ? 'Pedido '+data.orderName+' creado correctamente.' : 'Tu pedido fue creado correctamente.');
          }
          if(successWhatsApp && data.whatsappUrl){
            successWhatsApp.href = data.whatsappUrl;
          }
          if(successOverlay){
            successOverlay.classList.add('open');
            successOverlay.setAttribute('aria-hidden','false');
            lock();
          }

          // User requested direct WhatsApp confirmation.
          if(data.whatsappUrl){
            setTimeout(() => { window.location.href = data.whatsappUrl; }, 650);
          }
        }catch(err){
          showOrderError(err?.message || 'No pudimos registrar el pedido.');
          if(submitOrderButton){
            submitOrderButton.disabled = false;
            submitOrderButton.textContent = originalText;
          }
        }
      });
    }

    const video = root.querySelector('[data-magno-video], [data-magno-product-video-wrap] video');
    const sound = root.querySelector('[data-magno-video-sound]');
    if(video){
      video.muted = true; video.defaultMuted = true; video.setAttribute('muted',''); video.setAttribute('playsinline','');
      const tryPlay = () => { const p=video.play(); if(p?.catch) p.catch(()=>{}); };
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if(entry.isIntersecting && entry.intersectionRatio >= .45) tryPlay(); else video.pause();
      }),{threshold:[0,.25,.45,.75,1]});
      observer.observe(video);
      const unlockVideo = () => {
        const r=video.getBoundingClientRect(); if(r.top<innerHeight && r.bottom>0) tryPlay();
        document.removeEventListener('touchstart',unlockVideo); document.removeEventListener('click',unlockVideo);
      };
      document.addEventListener('touchstart',unlockVideo,{passive:true}); document.addEventListener('click',unlockVideo,{passive:true});
      sound?.addEventListener('click',() => { video.muted=!video.muted; sound.textContent=video.muted?'🔇 Activar sonido':'🔊 Silenciar'; if(video.paused) tryPlay(); });
    }

    syncUI();

    const restoreCompletedState = () => {
      const completed = readCompletedOrder();
      if(!completed) return;
      if(submitOrderButton){
        submitOrderButton.disabled = true;
        submitOrderButton.classList.add('magno-order-locked');
      }
      // Returning from WhatsApp / browser back must NEVER create a new order.
      // Keep the existing order available for WhatsApp confirmation.
      if(document.visibilityState === 'visible'){
        showCompletedOrder(completed);
      }
    };

    window.addEventListener('pageshow', restoreCompletedState);
    document.addEventListener('visibilitychange', () => {
      if(document.visibilityState === 'visible') restoreCompletedState();
    });
    restoreCompletedState();
  });
})();
